// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({1671: "js-legacy",8626: "head-common",878: "stage_automation_icon",9474: "vendor",}[chunkId] || chunkId) + "-" + {1671: "37bb5546c7ab35aa",3353: "edabd9582f1c5ba8",4276: "029283a156be33d7",8476: "592ef49c646f118e",8626: "a96704dc132e0d6f",878: "15c4a8bcf28e1bb9",8944: "50a9137c471f343b",9384: "02c0d8b39d96009e",9474: "42525c3d2afbcf17",}[chunkId] + ".js"
}